import {Injectable} from '@angular/core';
import {BasePagedCrudService} from "../shared/crud/base-crud.service";
import {EditUcetniObdobiDto, UcetniObdobiDto} from "./models/UcetniObdobiDtos"
import { HttpClient } from "@angular/common/http";
import {CrudSettings, MapperKeys, QueryParams} from "../shared/crud/abstractions/base-crud";
import {EnvironmentService} from '../core/environment/environment.service';
import {BehaviorSubject, lastValueFrom} from 'rxjs';
import {DialogService} from "../shared/dialog/dialog.service";
import {ShowType, SnackMessage} from "../shared/dialog/snack-bar/snack-bar/snack-bar.component";

@Injectable({
    providedIn: null
  })
export class UcetniObdobiCrudSettings implements CrudSettings<string, UcetniObdobiDto> {
  baseUrl = '';
  postUrl = undefined;
  queryParam = undefined;
  createSuffix = undefined;
  deleteSuffix = undefined;
  deleteIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  editSuffix = undefined;
  editMethod: 'PUT' | 'PATCH' = 'PUT';
  editIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  getListSuffix = 'Vse';
  getSuffix = undefined;
  getIdLocation: 'PATH' | 'QUERY' = 'QUERY';
  idGetter = (entity: UcetniObdobiDto) => entity.kodUj;

  mapper(id: string): QueryParams {
    const dict = new Map<string, string>();
    dict.set('kodUj', id);
    return { params: dict }
  }

  constructor(private environmentService: EnvironmentService) {
    this.baseUrl = this.environmentService.getConfig().api.pubgw + '/api/UcetniDenik/UcetniObdobi';
  }
}

@Injectable({
  providedIn: null
})
export class UcetniObdobiDataService extends BasePagedCrudService<any, any, any, any>{

  private client: HttpClient;
  private override settings : UcetniObdobiCrudSettings;
  public isBusy$: BehaviorSubject<boolean>

  constructor(client: HttpClient, settings: UcetniObdobiCrudSettings, override dialogService: DialogService) {
    super(client, settings, dialogService,);
    this.client = client;
    this.settings = settings;
    this.isBusy$ = new BehaviorSubject<boolean>(false)
}
  public override async create<T>(params: Map<MapperKeys,any>, body: T, useCreateSuffix: boolean = false, handle: boolean = true){
    let res: any = null;
    try {
      this.isBusy$.next(true);
      const urlParams = new URLSearchParams();
      params.forEach((value, key) => {
        urlParams.append(key, value.toString());
      });
      const apiUrl = `${this.settings.baseUrl}${urlParams ? `?${urlParams}` : ""}`;
      res = await lastValueFrom(this.client.post(apiUrl, body));
      this.dialogService.openSnackBar(SnackMessage.OperationSucess, ShowType.Success)
    } catch (e) {
      if (handle){
        await this.dialogService.handleError(e)
        return
      }
      throw  e as Error;
    } finally {
      this.isBusy$.next(false);
    }
    return res;
  }
  // @ts-ignore
  public override async delete(params: Map<MapperKeys,any>){
    const urlParams = new URLSearchParams();
    params.forEach((value, key) => {
      urlParams.append(key, value.toString());
    });
    this.isBusy$.next(true);
    const res$ = this.client.delete(`${this.settings.baseUrl}?${urlParams ? urlParams : ""}`);
    let res = await lastValueFrom(res$);
    this.isBusy$.next(false);
    return res;
  }

  public override async get(params: Map<MapperKeys,any>){
    let res: any;
    const urlParams = new URLSearchParams();
    params.forEach((value, key) => {
      urlParams.append(key, value.toString());
    });
    try {
      this.isBusy$.next(true);
      const res$ = this.client.get(`${this.settings.baseUrl}?${urlParams ? urlParams : ""}`);
      res = await lastValueFrom(res$);
      this.isBusy$.next(false);
    }
    catch (e) {
      await this.dialogService.handleError(e)
    }
    return res;
  }

  public override async edit(params: Map<MapperKeys,any>,body:EditUcetniObdobiDto)
  {
    let res: any;
    const urlParams = new URLSearchParams();
    params.forEach((value, key) => {
      urlParams.append(key, value.toString());
    });
    try {
      this.isBusy$.next(true);
      const res$ = this.client.put(`${this.settings.baseUrl}?${urlParams ? urlParams : ""}`,body);
      res = await lastValueFrom(res$);
      this.isBusy$.next(false);
      this.dialogService.openSnackBar(SnackMessage.EditEntitySucess, ShowType.Success);
    }
    catch (e) {
      await this.dialogService.handleError(e);
    }
    return res;
  }
}
